// 根据jobNos查出来委托单位是否是否黑名单
import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryAConfigFunc(data) {
  return request({
    url: URL.wt.queryAConfigUrl,
    method: 'post',
    data
  })
}

export function queryForUuidFunc(uuid) {
  return request({
    url: URL.wt.getAdvertisingUrl,
    method: 'get',
    params: { uuid }
  })
}

export function queryASCForUuidFunc(uuid) {
  return request({
    url: URL.wt.getAdvertisingSpaceUrl,
    method: 'get',
    params: { uuid }
  })
}

export function getAdvertisingSpaceForKeyFunc(title) {
  return request({
    url: URL.wt.getAdvertisingSpaceForKeyUrl,
    method: 'get',
    params: { title }
  })
}

export function saveAConfigFunc(data) {
  return request({
    url: URL.wt.saveAConfigUrl,
    method: 'post',
    data
  })
}

export function saveASConfigFunc(data) {
  return request({
    url: URL.wt.saveASConfigUrl,
    method: 'post',
    data
  })
}

export function deleteAConfigFunc(data) {
  return request({
    url: URL.wt.deleteAConfigUrl,
    method: 'post',
    data
  })
}

export function queryASConfigFunc(data) {
  return request({
    url: URL.wt.queryASConfigUrl,
    method: 'post',
    data
  })
}

export function queryPromotionDataFunc(data) {
  return request({
    url: URL.wt.queryPromotionDataUrl,
    method: 'post',
    data
  })
}

export function queryClickUserListFunc(data) {
  return request({
    url: URL.wt.queryClickUserListUrl,
    method: 'post',
    data
  })
}

export function getAdvertisingDataFunc(data) {
  return request({
    url: URL.wt.getAdvertisingDataUrl,
    method: 'post',
    data
  })
}

export function updateACFunc(data) {
  return request({
    url: URL.wt.updateACUrl,
    method: 'post',
    data
  })
}

export function updateASCFunc(data) {
  return request({
    url: URL.wt.updateASCUrl,
    method: 'post',
    data
  })
}

export function insertDataLogFunc(data) {
  return request({
    url: URL.wt.dataLogUrl,
    method: 'post',
    data
  })
}
